export default {
  'Favarite audience': '收藏的客商',
  'Favarite exhibit': '收藏的展品',
  'Favarite exhibitor': '收藏的展商',
  'No employee was added in this company for chat at the moment': '暂无员工可沟通或邀约'
}